module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution3.a33ecd93.png";